import styled from 'styled-components'

export const MisionVisionContainer = styled.div`
    display: flex;
    justify-content: center;
    max-width: 1500px;
    margin: 0 auto;
    margin-top: 100px;
    padding-bottom: 100px;

    @media (max-width: 550px) {
      /* Phones */
        margin: 50px 0;
        flex-direction: column;
        align-items: center;
    }

    @media (max-width: 1100px) {
        /* Tablets */
         flex-direction: column;
         align-items: center;
         margin: 50px 0;
    }
`

export const MisionVisionItem = styled.div`
    display: flex;
    flex-direction: column;
    color: white;
    background-image: linear-gradient(rgba(40, 44, 52, 1), rgba(118, 130, 154, 0.05));
    width: 200px;
    border-radius: 0px 47px 0px 47px;
    margin-right: 40px;
    padding: 0 50px 50px 50px;

    p{
        margin-top: 15px;
    }

    @media (max-width: 550px) {
        /* Phones */
        width: 60%;
        margin-right: 0;
        margin-top: 40px;
    }

    @media (max-width: 1100px) {
        /* Tablets */
        width: 60%;
        margin-top: 40px;
    }
`

export const IconContainer = styled.div`
    width: 80px;
    height: 80px;
    background-image: linear-gradient(rgba(124, 1, 0, 1), rgba(226, 2, 0, 1));
    border-radius: 50%;
    color: #E10200;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    margin-top: -30px;
    margin-bottom: 20px;

    img{
        width: 40px;
        height: 40px;
    }
`

export const ValueItem = styled.div`
    display: flex;
    align-items: center;

    svg{
        margin-top: 10px;
        margin-right: 10px;
        color: rgba(186, 0, 1, 1)
    }
`